export default __webpack_public_path__ + "static/hip-dsyplasia-metamorphosis-decf9d8a33d428c37ba70308f63d3bf4.png";